import React from "react";
import { useAuth } from "./AuthContext";
import LoginAdminPage from "../ui/LoginAdmin";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          fontSize: "18px",
        }}
      >
        로딩 중...
      </div>
    );
  }

  if (!isAuthenticated) {
    return <LoginAdminPage />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
